import { combineReducers } from 'redux';

import current from './current';
import list from './list';
import selected from './selected';

export default combineReducers({
  current,
  list,
  selected,
});
